import { View, Text } from 'react-native'
import React, { useEffect } from 'react'
import { ThemedView, ThemedText } from '@app/theme'
import LottieView from 'lottie-react-native'
import Button from '@app/sharedComponents/Button/Button'

const BankSuccessModal = ({ lottie, onPress }: { lottie: any, onPress: () => void }) => {

  useEffect(() => {
    const timer = setTimeout(() => {
      onPress()
    }, 5000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <ThemedView padding='lg' justifyContent='center' alignItems='center'>
      <LottieView source={lottie} autoPlay loop style={{ width: 70, height: 70 }} />
      <ThemedText variant='h5s' mb='sm' color='text-primary'>Account verified successfully</ThemedText>
      <ThemedView mb='2xl'>
        <ThemedText textAlign='center' variant='b3r' color='text-secondary'>You will be redirected to next step in few seconds</ThemedText>
      </ThemedView>

      <Button size='MD' type='OUTLINED' label='Continue' handlePress={onPress} bg='#1434CB' textColor='text-primary' />
    </ThemedView>
  )
}

export default BankSuccessModal